<!-- eslint-disable max-lines -->
<template>
    <div class="global-monitoring">
        <div class="card-content">
            <card class="card-content-item" v-for="(item, index) in carList" :key="index"
                :title="item.title"
                :leftPercentage="item.leftPercentage"
                :rightPercentage="item.rightPercentage"
                :leftColor="item.leftColor"
                :rightColor="item.rightColor"
                :leftProgressDesc="item.leftProgressDesc"
                :rightProgressDesc="item.rightProgressDesc"
                :leftSatelliteInformation="item.leftSatelliteInformation"
                :rightSatelliteInformation="item.rightSatelliteInformation"
                :leftSatelliteInformationNum="item.leftSatelliteInformationNum"
                :rightSatelliteInformationNum="item.rightSatelliteInformationNum"
                >
            </card>
        </div>
    </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import card from '@/components/lots/card';
import api from '@/modules/transport/otp/api/orderPanel.js';
import { mapState } from 'vuex';

export default {
    components: {
        card
    },
    data() {
        return {
            carList: [],
            cancelRequest: () => {},
            loadingObj: { close: () => {} }
        };
    },
    methods: {
        loading(status = true) {
            this.loadingObj.close();
            if (status) {
                this.loadingObj = this.$loading({
                    target: '.global-monitoring > .card-content',
                    background: 'rgba(255, 255, 255, .7)'
                });
            }
        },
        getData() {
            this.loading();
            this.cancelRequest(); // 取消还未响应的异步请求
            this.carList = [];
            api.indicators({ carrierCode: this.supplier.supplierCode }, (c) => { this.cancelRequest = c; }).then(res => {
                if (res) {
                    const sort = [
                        {
                            code: 'ARRIVAL',
                            title: '到车',
                            leftColor: '#00c0c1',
                            rightColor: '#00c0c1',
                            leftProgressDesc: '当日及时率',
                            rightProgressDesc: '当月及时率',
                            leftSatelliteInformation: '应到车',
                            rightSatelliteInformation: '超时未到'
                        }, {
                            code: 'DEPARTURE',
                            title: '发车',
                            leftColor: '#6CC100',
                            rightColor: '#6CC100',
                            leftProgressDesc: '当日及时率',
                            rightProgressDesc: '当月及时率',
                            leftSatelliteInformation: '应发车',
                            rightSatelliteInformation: '超时未发'
                        }, {
                            code: 'DELIVERY',
                            title: '配送',
                            leftColor: '#008BED',
                            rightColor: '#008BED',
                            leftProgressDesc: '当日及时率',
                            rightProgressDesc: '当月及时率',
                            leftSatelliteInformation: '应配送',
                            rightSatelliteInformation: '超时未配'
                        }, {
                            code: 'UPLOAD',
                            title: '回单上传',
                            leftColor: '#CD7FFF',
                            rightColor: '#CD7FFF',
                            leftProgressDesc: '当日及时率',
                            rightProgressDesc: '当月及时率',
                            leftSatelliteInformation: '应上传',
                            rightSatelliteInformation: '超时未传'
                        }, {
                            code: 'RETURN',
                            title: '退货',
                            leftColor: '#FFBA00',
                            rightColor: '#FFBA00',
                            leftProgressDesc: '当日及时率',
                            rightProgressDesc: '当月及时率',
                            leftSatelliteInformation: '应退回',
                            rightSatelliteInformation: '超时未退'
                        }, {
                            code: 'SATISFACTION',
                            title: '满意度',
                            leftColor: '#7A77FF',
                            rightColor: '#7A77FF',
                            leftProgressDesc: '当日及时率',
                            rightProgressDesc: '当月及时率',
                            leftSatelliteInformation: '总单量',
                            rightSatelliteInformation: '不满意'
                        }
                    ];

                    sort.forEach(item => {
                        const data = res.data[item.code];

                        this.carList.push({
                            title: item.title,
                            leftColor: item.leftColor,
                            rightColor: item.rightColor,
                            leftProgressDesc: item.leftProgressDesc,
                            rightProgressDesc: item.rightProgressDesc,
                            leftSatelliteInformation: item.leftSatelliteInformation,
                            rightSatelliteInformation: item.rightSatelliteInformation,
                            leftPercentage: data.dayIndicator,
                            rightPercentage: data.monthIndicator,
                            leftSatelliteInformationNum: data.requireCount,
                            rightSatelliteInformationNum: data.timeOutCount
                        });
                    });
                }
            }).catch(() => {
            }).finally(() => {
                this.loading(false);
            });
        }
    },
    mounted () {
        this.getData();
    },
    computed: {
        ...mapState({ supplier: state => state.supplier })
    }
};
</script>

<style lang="less">
.global-monitoring {
    .card-content {
        display: flex;
        flex-wrap: wrap;
        padding: 30px 0 30px 12px;
        min-height: 300px;
    }
    .card-content-item {
        width: 30%;
        margin: 0 3.3% 3.3% 0;
    }
}
</style>